export enum DispatchMessageOrigin {
  unifiedSend = "unified-send",
  chainMarketingCampaign = "chain-marketing-campaign",
  discountMarketingCampaign = "discount-marketing-campaign",
  recurringSend = "recurring-send",
}

export namespace DispatchMessageOrigin {
  export const translateOrigin = (origin: DispatchMessageOrigin): string => {
    switch (origin) {
      case DispatchMessageOrigin.chainMarketingCampaign:
        return "Campanha";
      case DispatchMessageOrigin.discountMarketingCampaign:
        return "Desconto";
      case DispatchMessageOrigin.unifiedSend:
        return "Envio Único";
      case DispatchMessageOrigin.recurringSend:
        return "Envio Recorrente";
      default: return "";
    };
  };

  export const DispatchMessageOriginChoices = Object.values(DispatchMessageOrigin).filter(x => typeof x === "string")
    .map(type => {
      return ({
        id: type,
        name: DispatchMessageOrigin.translateOrigin(type)
      });
    });
};
